module.exports = new __parcel__URL__("shop_machines_glfhers_arcade.8b723beb.png").toString();